import styled from "styled-components";

export const Container = styled.div`
  padding: 24px;
  margin: 0 auto;
`;

export const FiltersWrapper = styled.div`
  margin-bottom: 24px;
`;
